var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"value":_vm.localValue,"searchable":false,"multiple":false,"filterable":false},on:{"input":_vm.onSelectionChanged}},'v-select',{options: _vm.options, getOptionLabel: _vm.getOptionLabel, placeholder: _vm.placeholder, disabled: _vm.disabled},false),[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a07fe67","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/SingleSelect.vue
// module id = 634
// module chunks = 1